<template>
  <div class="mobile" :style="{ height: screenHeight + 'px' }">
    <!-- <Header /> -->
    <swiper
      :options="swiperOption"
      ref="mySwiper"
      :style="{ height: screenHeight + 'px' }"
    >
      <!-- slides -->
      <swiper-slide>
        <page00 :screenHeight="screenHeight" />
        <!-- <div class="page00__box">
        </div> -->
      </swiper-slide>
      <swiper-slide><page04 /> </swiper-slide>
      <swiper-slide><page05 /> </swiper-slide>
      <swiper-slide><page06 /> </swiper-slide>
      <swiper-slide><page07 /> </swiper-slide>
      <swiper-slide><page08 /> </swiper-slide>
      <swiper-slide><page01 /> </swiper-slide>
      <swiper-slide>
        <div :style="{ height: screenHeight + 'px' }" class="page01__box">
          <page02 />
        </div>
      </swiper-slide>
      <swiper-slide><page03 /> </swiper-slide>
      <swiper-slide><page09 /> </swiper-slide>
      <!-- Optional controls -->
      <div class="swiper-pagination" slot="pagination"></div>
    </swiper>
  </div>
</template>
<script>
// import Header from "@/components/Mobile/Header";
import page00 from "./pages/page00.vue";
import page01 from "./pages/page01.vue";
import page02 from "./pages/page02.vue";
import page03 from "./pages/page03.vue";
import page04 from "./pages/page04.vue";
import page05 from "./pages/page05.vue";
import page06 from "./pages/page06.vue";
import page07 from "./pages/page07.vue";
import page08 from "./pages/page08.vue";
import page09 from "./pages/page09.vue";
export default {
  components: {
    // Header,
    page00,
    page01,
    page02,
    page03,
    page04,
    page05,
    page06,
    page07,
    page08,
    page09
  },
  data() {
    return {
      swiperOption: {
        direction: "vertical",
        pagination: {
          el: ".swiper-pagination",
          type: "progressbar"
        }
      },
      devHeight: 568,
      screenHeight: document.documentElement.clientHeight // 屏幕高度
    };
  },
  mounted() {
    console.log(this.swiper);
    this.screenHeight = document.documentElement.clientHeight; // 窗口高度
    window.onresize = function() {
      // 定义窗口大小变更通知事件
      this.screenHeight = document.documentElement.clientHeight; // 窗口高度
    };
    // current swiper instance
    // 然后你就可以使用当前上下文内的swiper对象去做你想做的事了
    this.$refs.mySwiper.swiper.slideTo(0, 1000, false);
    let swiper_o = this.$refs.mySwiper.swiper;
    var startScroll, touchStart, touchCurrent;
    swiper_o.slides.on(
      "touchstart",
      function(e) {
        startScroll = this.scrollTop;
        touchStart = e.targetTouches[0].pageY;
      },
      true
    );
    swiper_o.slides.on(
      "touchmove",
      function(e) {
        touchCurrent = e.targetTouches[0].pageY;
        var touchesDiff = touchCurrent - touchStart;
        var slide = this;
        var onlyScrolling =
          slide.scrollHeight > slide.offsetHeight &&
          ((touchesDiff < 0 && startScroll === 0) ||
            (touchesDiff > 0 &&
              startScroll === slide.scrollHeight - slide.offsetHeight) ||
            (startScroll > 0 &&
              startScroll < slide.scrollHeight - slide.offsetHeight));
        if (onlyScrolling) {
          e.stopPropagation();
        }
      },
      true
    );
  }
};
</script>
<style lang="scss" scoped>
.mobile {
  min-height: 100%;
  // .page00__box {
  //   padding: 0.35rem 0 0.37rem;
  //   background: rgba(248, 250, 253, 1);
  // }
  .swiper-slide {
    background-color: rgba(248, 250, 253, 1);
    background-image: url("../../../assets/img/mobile/public/mobileBdg.png");
    background-repeat: no-repeat;
    background-position: top right;
    background-size: auto 100%;
    overflow-y: auto; /*overflow :auto 必须*/
  }
}
.swiper-container-vertical > .swiper-pagination-progressbar,
.swiper-container-horizontal
  > .swiper-pagination-progressbar.swiper-pagination-progressbar-opposite {
  width: 3px;
  height: 100%;
  left: 0;
  top: 0;
}
.swiper-pagination-progressbar {
  background: none;
  position: absolute;
}
</style>
<style lang="scss">
html,
body {
  min-height: 100%;
  background-color: rgba(248, 250, 253, 1);
}
</style>
